import { render, staticRenderFns } from "./buy-now-confirmation-onboarding.vue?vue&type=template&id=909390b0&scoped=true&"
import script from "./buy-now-confirmation-onboarding.vue?vue&type=script&lang=js&"
export * from "./buy-now-confirmation-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./buy-now-confirmation-onboarding.vue?vue&type=style&index=0&id=909390b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909390b0",
  null
  
)

export default component.exports